import { Grid, Typography } from '@mui/material';
import React from 'react';
import parse from 'html-react-parser';
import { LevelsTableRows } from '../new-start-page';
import colors from '@/shared/colors';

interface Props {
  levelsTableRows: LevelsTableRows;
  levelsTableHeaders: string[];
}

const LevelsTable = ({ levelsTableHeaders, levelsTableRows }: Props) => {
  return (
    <>
      <Grid
        container
        spacing={2}
        sx={{
          backgroundColor: '#ECF8FF',
          marginTop: '60px',
          marginLeft: '8px',
        }}
      >
        <Grid item xs={1.714}></Grid>
        {levelsTableHeaders.map((header, index) => (
          <Grid
            key={index}
            item
            xs={1.714}
            style={{
              backgroundColor: colors.cerulean,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              padding: '30px 15px',
              borderBottom: '1px solid #ECF8FF',
              borderRight: '1px solid #ECF8FF',
            }}
          >
            <Typography
              style={{ color: 'white', fontSize: '48px', fontWeight: '400' }}
            >
              {index}
            </Typography>
            <Typography
              style={{ color: 'white', fontSize: '14px', fontWeight: '400' }}
            >
              {header}
            </Typography>
          </Grid>
        ))}
        {Object.entries(levelsTableRows).map((rows, index) => {
          return rows[1].map((cell, index) => {
            return index === 0 ? (
              <Grid
                item
                xs={1.714}
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  padding: '15px',
                  backgroundColor: colors.cerulean,
                  borderBottom: '0.5px solid #ECF8FF',
                  borderRight: '0.5px solid #ECF8FF',
                }}
              >
                <div>
                  <Typography
                    style={{
                      color: 'white',
                      fontSize: '20px',
                      fontWeight: '700',
                    }}
                  >
                    {levelsTableRows[index]}
                  </Typography>
                  <Typography
                    style={{
                      color: 'white',
                      fontSize: '20px',
                      fontWeight: '700',
                    }}
                  >
                    {parse(rows[0])}
                  </Typography>{' '}
                  <Typography
                    style={{
                      color: 'white',
                      fontSize: '14px',
                      fontWeight: '400',
                    }}
                  >
                    {parse(cell)}
                  </Typography>{' '}
                </div>
              </Grid>
            ) : (
              <Grid
                item
                xs={1.714}
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  flexDirection: 'row',
                  padding: '15px',
                  borderLeft: index !== 1 ? '0.5px solid #023C5D' : '',
                  borderBottom: '0.5px solid #023C5D',
                  backgroundColor: '#8CCAEE5E',
                  minHeight: '210px',
                }}
              >
                <Typography
                  style={{
                    color: 'black',
                    fontSize: '14px',
                    fontWeight: '400',
                  }}
                >
                  {parse(cell)}
                </Typography>
              </Grid>
            );
          });
        })}
      </Grid>
    </>
  );
};

export default LevelsTable;
